'use strict';

var modalModule = require('bootstrap/js/src/modal.js');
var Modal = modalModule.default || modalModule;

var SELECTORS = {
    modal: '.js-password-policy-modal',
    passwordField: '.js-password'
};

module.exports = {
    forcePasswordModal: function () {
        var modalEl = document.querySelector(SELECTORS.modal);
        if (!modalEl) {
            return;
        }
        // Skip pages that already let the customer set a new password.
        if (document.querySelector(SELECTORS.passwordField)) {
            return;
        }
        Modal.getOrCreateInstance(modalEl, {
            backdrop: 'static',
            keyboard: false
        }).show();
    }
};
